import * as React from 'react';
import { useLeapData } from '../../hooks/useLeapData';
import { useLeapState } from '../../hooks/useLeapState';

import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';

import SearchBox from '../../components/controls/SearchBox';
import MultiBox from '../../components/controls/MultiBox';
import Text from '../../components/controls/Text';

type Props = { state: any, controller: any }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const branch = useLeapData("branch", "branca", page, "branches")
    const healthService = useLeapData("healthService", "prestazioni", page, "healthServices")
    const medicalSpecialtyTypesId = useLeapData("medicalSpecialtyTypesId", "Tipo specialità", page)

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <SearchBox {...branch} className="ms-sm12" parentController={props.controller} children={[{ name: "healthService", lookup: "healthServices", controller: props.controller }]} required />
                    </Row>
                    <Row>
                        <MultiBox {...healthService} className="ms-sm12" titleType='text' />
                    </Row>
                    <Row>
                        <Text {...medicalSpecialtyTypesId} className="ms-sm12" value="1" hidden />
                    </Row>
                </Section>
            </Grid>
        </>
    );
}
